import React from 'react'
import '../courses.css'
import Menubar from '../../home/menubar/Menubar'
import Address from '../../home/footer/Address'
import Carousel from '../../home/carousel/Carousel'
import { tallyimg, tallyData, tally_gif } from '../../home/data'
import Hower from '../../home/hower/Hower'
import Typewriter from '../../home/lazy loader/Typewriter'
import ScrollToTopProgress from '../../home/header/ScrollToTopProgress'
import Header from '../../home/header/Header'

function Tallycs() {
  const imgUrl = tallyimg;
  const txt = tallyData;
  const gif = tally_gif;
  return (
    <div>
      <Header/>
      <Menubar/>
      <Carousel imgUrl={imgUrl}/>
      <Hower gif={gif}/>
      <Typewriter txt={txt}/>

      
        <div className='pannel-container'>
          <div className="accordion accordion-flush" id="accordionFlushExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingOne">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
        <p className='panel-title'>TALLY Level-1</p>
      </button>
    </h2>
    <div id="flush-collapseOne" className="accordion-collapse collapse show" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          <li className='list'>What is Tally ?</li>
          <li className='list'>Fundamentals of accounting</li>
          <li className='list'>Introduction of Tally</li>
          <li className='list'>Meaning of company creation and opening accounting in Tally</li>
          <li className='list'>Opening a ledger account and how to create a voucher</li>
          <li className='list'>How to modify a company or industry detail</li>
          <li className='list'>How to set the features of a company</li>
          <li className='list'>Selecting the cost category and cost center</li>
        </ul>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="flush-headingTwo">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
      <p className='panel-title'>TALLY Level-2</p>
      </button>
    </h2>
    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
      <div className="accordion-body">
        <ul className='uno-li'>
          	<li className='list'>How to create a godown and how to maintain an inventory</li>
            <li className='list'>How to set price list and the budget</li>
            <li className='list'>A brief introduction of F11 and F12</li>
            <li className='list'>How to produce profit and loss balance sheet from accounting</li>
            <li className='list'>Introduction to VAT</li>
            <li className='list'>Calculation of VAT</li>
            <li className='list'>Introduction to TDS</li>
            <li className='list'>Calculation of TDS</li>
            <li className='list'>How to add excise duty and customs duty</li>
        </ul>
      </div>
    </div>
  </div>
    </div>
        </div>

        <div className="table-header">
	<h4><u><b>COURSE DETAILS :</b></u></h4>
<table className="table">
  <thead>
	<tr>
	<th colSpan="2" className="heading">TALLY</th>
	</tr>
  </thead>
<tbody>
<tr>
	<th>Accounting</th>
	<td>It is the most important feature of Tally ERP. the very first thing that comes to anyone’s mind after listening about Tally is Accounting.</td>
</tr>
<tr>
	<th>Billing</th>
	<td>Billing is a significant part of any business. As and when you pass an accounting entry synchronously a bill is generated which you can use for raising or sending an invoice. Most people believe that Billing is a part of Accounting which is not true when it comes to business. Billing Option present in Tally eliminates the task of entering separate accounting.</td>
</tr>
<tr>
	<th>Payroll</th>
	<td>This feature can be used when you have a good number of employees. To maintain Payroll in Tally, functions such as employee groups, employee categories, pay heads, attendance, and course employees are used.</td>
</tr>
<tr>
	<th>Banking</th>
	<td>In this era of digitalization, no business can survive without Banking. With the help of Tally ERP, TDS GST both direct and indirect tax can be calculated automatically and its returns will be also be filed online.</td>
</tr>
<tr>
	<th>Taxation</th>
	<td>For any business to survive it shouldn’t operate in isolation. The Business should work in cooperation with State as well as Central Government by paying appropriate Taxes. Calculation of Taxes based on the income, sale, and dispatch is quite hectic. Tally makes it easy for you to prepare any bill or invoice as it can give VAT, Income Tax, Excise, Customs, Service tax, etc.</td>
</tr>
<tr>
	<th>Inventory</th>
	<td>Maintenance of Stock is of utmost importance for any business. It’s vital as it gives better control over business sales. Thus, the movement of stock is an integral part that can be kept in control.</td>
</tr>
</tbody>
</table>
</div>

      <Address/>
      <ScrollToTopProgress/>
    </div>
  )
}

export default Tallycs